module.exports = __webpack_public_path__ + "img/logo.e962b32f.png";